var moduleMap = {
	"./App": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_reduxjs_toolkit_dist_redux-toolkit_esm_js-node_modules_drift-ui_dist_dri-4f1ee3"), __webpack_require__.e("vendors-node_modules_shamrock-core_common_analytics_firebase-analytics_js"), __webpack_require__.e("webpack_sharing_consume_default_react-dom_react-dom"), __webpack_require__.e("src_features_debtor-search_DebtorSearch_tsx"), __webpack_require__.e("src_App_tsx")]).then(() => (() => ((__webpack_require__(/*! ./src/App */ "./src/App.tsx")))));
	},
	"./DebtorSearch": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_reduxjs_toolkit_dist_redux-toolkit_esm_js-node_modules_drift-ui_dist_dri-4f1ee3"), __webpack_require__.e("webpack_sharing_consume_default_react-dom_react-dom"), __webpack_require__.e("src_features_debtor-search_DebtorSearch_tsx")]).then(() => (() => ((__webpack_require__(/*! ./src/features/debtor-search/DebtorSearch */ "./src/features/debtor-search/DebtorSearch.tsx")))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});